import { render, staticRenderFns } from "./Basecharts.vue?vue&type=template&id=2590d878&scoped=true&"
import script from "./Basecharts.vue?vue&type=script&lang=js&"
export * from "./Basecharts.vue?vue&type=script&lang=js&"
import style0 from "./Basecharts.vue?vue&type=style&index=0&id=2590d878&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2590d878",
  null
  
)

export default component.exports